// 小米锁屏
export default {
  // 孟加拉语
  "bn-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192497663-0",
        slot: "/23161678951/bn_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 7678453115,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 1048092433,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 1847541938,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 9534460269,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 1113044768,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 希腊语
  "el-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192545976-0",
        slot: "/23161678951/el_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 8543439077,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 9016381679,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 7703300007,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 6908296920,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 5917275734,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 希伯来语
  "he-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192567035-0",
        slot: "/23161678951/he_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 6390218331,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 8859133849,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 7546052177,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 5982228060,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 3606807164,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 韩语
  "ko-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192607790-0",
        slot: "/23161678951/ko_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 8416819712,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 1655970241,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 7103738043,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 8888389164,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 7575307495,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 乌克兰语
  "uk-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192825821-0",
        slot: "/23161678951/uk_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 1851411360,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 8225248028,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 6912166350,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4286003012,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 2259401630,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 缅甸语
  "my-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192648554-0",
        slot: "/23161678951/my_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 8264237476,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 8029806901,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 1698829121,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 8072665781,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 6007074952,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 俄语
  "ru-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192711436-0",
        slot: "/23161678951/ru_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 7131119209,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 2820339108,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 9214357068,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 6588193720,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 5275112057,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 阿塞拜疆语
  "az-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192459538-0",
        slot: "/23161678951/az_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 5403643562,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 8696817472,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 2777480221,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 1464398554,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 6556404133,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 匈牙利语
  "hu-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192587631-0",
        slot: "/23161678951/hu_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 8204527722,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 3819895312,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 3463837943,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 2437195729,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 8811032386,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 罗马尼亚语
  "ro-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192689975-0",
        slot: "/23161678951/ro_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 2315241957,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 7375996942,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 3252919104,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 8959745193,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4749833604,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 塞尔维亚语
  "sr-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192782736-0",
        slot: "/23161678951/sr_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 1112505769,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 8799424093,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4860179085,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 3436751936,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 2234015743,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 保加利亚语
  "bg-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192479423-0",
        slot: "/23161678951/bg_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 9646102919,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 3428216910,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 9563176585,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4773884332,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 3460802667,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 斯洛伐克语
  "sk-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192759867-0",
        slot: "/23161678951/sk_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 6937013244,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 8521557657,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 8497506927,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 9371604896,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 6745441555,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 繁体中文
  "zh-hant-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192844187-0",
        slot: "/23161678951/zh-hant_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 9643067634,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 7455091839,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4119278216,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 8619460699,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4680215681,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 僧伽罗语
  "si-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192738096-0",
        slot: "/23161678951/si_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 5862808562,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 6825332609,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 6883707197,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 7675379846,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 3736134839,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 捷克语
  "cs-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1742192526275-0",
        slot: "/23161678951/cs_mils_comfortweather_20250317_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 1932098571,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 1064404301,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 5320679245,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4007597578,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 8796889824,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 巴西葡萄牙语
  "pt-br-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763404972-0",
        slot: "/23161678951/pt_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 1833578613,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 4907289897,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 2754382811,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 2127696858,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 2057041525,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 2534890965,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 欧洲-葡萄牙语
  "pt-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763388669-0",
        slot: "/23161678951/pt_br_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 2763516904,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 2281126552,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 1221809291,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 7188451843,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 6734653135,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 5421571469,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 西班牙语
  "es-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763251083-0",
        slot: "/23161678951/es_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 5564378980,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "top-banner",
      },

      {
        type: "ads",
        slot: 5134520605,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 2343319271,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 1482326454,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 3057635149,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 6838493282,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 阿拉伯语
  "arabic-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763216410-0",
        slot: "/23161678951/arabic_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 7926818447,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },

      {
        type: "ads",
        slot: 6990495931,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 6543081444,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 5492226790,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4777910927,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 5229999775,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 土耳其语
  "tr-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763442413-0",
        slot: "/23161678951/tr_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 7998970638,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },

      {
        type: "ads",
        slot: 9973845949,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 6613736770,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 2938215643,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 9838665913,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4997402773,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 法语
  "fr-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763271650-0",
        slot: "/23161678951/fr_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 5181235607,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },

      {
        type: "ads",
        slot: 1462868907,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 6685888967,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 7212502577,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 2371239437,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 9048328423,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 意大利语
  "it-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763333363-0",
        slot: "/23161678951/it_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 1394594910,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },

      {
        type: "ads",
        slot: 9149787237,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 2555072262,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4586339237,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 3273257569,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4846856397,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 乌尔都语
  "urdu-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763458252-0",
        slot: "/23161678951/urdu_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 3492749414,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },

      {
        type: "ads",
        slot: 4721519264,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 3796001743,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 6455349902,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4989663913,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 9647094227,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 越南语
  "vi-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763474559-0",
        slot: "/23161678951/vi_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 1266041322,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },

      {
        type: "ads",
        slot: 6523623890,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 2179667743,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 7281448042,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4394767548,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 9866586077,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 泰语
  "th-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763423406-0",
        slot: "/23161678951/th_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 2171928881,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "top-banner",
      },

      {
        type: "ads",
        slot: 7156110917,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 8553504401,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 7240422731,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 5465701868,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 7639877989,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 英语
  "en-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763232414-0",
        slot: "/23161678951/en_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 1980357197,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 3629867245,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 1526456855,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 7232683874,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 6587211843,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4725940039,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 日语
  "jp-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763352919-0",
        slot: "/23161678951/jp_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 6637787503,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 3300626381,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 2890114182,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 9667275528,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4422687702,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 2647966836,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 德语
  "ger-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763297077-0",
        slot: "/23161678951/ger_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 5544197684,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 4529947575,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 5082558488,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 3101867177,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4822142951,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 9786695027,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 印尼语
  "id-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763314191-0",
        slot: "/23161678951/id_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 5865458435,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },

      {
        type: "ads",
        slot: 3322745481,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 6678451423,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 8184500010,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 5138139049,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 5785567389,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 波兰语
  "po-mils.comfortweather.com": {
    "320x100": [
      {
        type: "adx",
        id: "div-gpt-ad-1741763370119-0",
        slot: "/23161678951/po_mils_comfortweather_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minWeight: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 5127462965,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },

      {
        type: "ads",
        slot: 2089554862,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 2852092339,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 3311818411,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 9685655079,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 9250540808,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
};
